// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.grid-container[data-v-8a47ae8e] {\n\tdisplay: grid;\n\tgrid-auto-rows: auto;\n\toverflow-y:visible;\n}\n.grid-container.edit-mode[data-v-8a47ae8e]{\n\tpadding-bottom: 100px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
